<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 0.233887C3.71875 0.233887 0.25 3.70264 0.25 7.98389C0.25 12.2651 3.71875 15.7339 8 15.7339C12.2812 15.7339 15.75 12.2651 15.75 7.98389C15.75 3.70264 12.2812 0.233887 8 0.233887ZM8 14.2339C4.53125 14.2339 1.75 11.4526 1.75 7.98389C1.75 4.54639 4.53125 1.73389 8 1.73389C11.4375 1.73389 14.25 4.54639 14.25 7.98389C14.25 11.4526 11.4375 14.2339 8 14.2339ZM9.90625 10.9839C10.0938 11.1089 10.3125 11.0776 10.4375 10.8901L11.0312 10.1089C11.1562 9.92139 11.125 9.70264 10.9375 9.57764L8.875 8.04639V3.60889C8.875 3.42139 8.6875 3.23389 8.5 3.23389H7.5C7.28125 3.23389 7.125 3.42139 7.125 3.60889V8.76514C7.125 8.85889 7.15625 8.98389 7.25 9.04639L9.90625 10.9839Z" />
  </svg>
</template>
